module.exports = __webpack_public_path__ + "img/feature-tile-icon-06.5eb10fd5.svg";